/**
 * 配置
 **/
/* 选择全部类目值 */
export const DEF_ALL_TYPE_NUM: string = '-1';
/* “全部”类目默认文案 */
export const DEF_ALL_TYPE_TEXT: string = '全部';
/* 默认父类ID */
export const DEF_PARENTNO: string = '0';
